export default "__VITE_ASSET__m16CJeMQ__"